import { Tooltip } from '@base-ui-components/react/tooltip';
import { FC, ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const PreFilledByAITooltip: FC<{
  hide?: boolean;
  enabled?: boolean;
  description?: string | null;
  align?: Tooltip.Positioner.Props['align'];
  children: ReactElement;
}> = ({ children, hide, enabled, description, align = 'end' }) => {
  const { t } = useTranslation();

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (hide) {
      setVisible(false);
    }
  }, [hide]);

  const onOpenChange = (wantToBeVisible: boolean) => {
    if (wantToBeVisible && hide) return;

    setVisible(wantToBeVisible);
  };

  if (!enabled) return children;

  return (
    <Tooltip.Provider>
      <Tooltip.Root
        open={visible}
        onOpenChange={onOpenChange}
        delay={200}
        hoverable={false}
      >
        <Tooltip.Trigger render={children} />
        <Tooltip.Portal>
          <Tooltip.Positioner
            align={align}
            side="top"
            sideOffset={8}
            className="z-[100]"
          >
            <Tooltip.Popup className="transition-[transform,opacity] data-[ending-style]:translate-y-2 data-[ending-style]:opacity-0 data-[instant]:duration-0 data-[starting-style]:translate-y-2 data-[starting-style]:opacity-0">
              <div className="max-w-[16rem] flex flex-col gap-1 bg-white border border-primary-50 py-3 px-3 rounded-[0.625rem] shadow-[0px_5px_15px_0px_rgba(53,26,77,0.1),0px_4px_6px_0px_rgba(53,26,77,0.05)]">
                <div className="flex">
                  <p className="text-sm font-semibold !bg-clip-text ai-gradient inline-block leading-tight">
                    {t('prefilled_by_ai')}
                  </p>
                </div>
                {description && (
                  <p className="text-xs text-primary-700 leading-tight">
                    {description}
                  </p>
                )}
              </div>
            </Tooltip.Popup>
          </Tooltip.Positioner>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default PreFilledByAITooltip;
